
















































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ChooseSubjectVue from "@/components/ChooseSubject.vue";
import DropdownVue from "@/components/Dropdown.vue";
import DimInventoryTypeList from "@/data/DimInventoryTypeList";
import MonthSelectorVue from "../components/MonthSelector.vue";
import PrintVue from "@/components/Inventory/Print.vue";
import { VNode } from "vue";
import version from "@/version";

enum OrderSource {
	"凭证" = 1,
	"票据" = 2,
	"录入" = 3,
}

export class InventoryOrderData {
	checked?: boolean;
	orderDate: string;
	dimInventoryNo: string;
	dimInventoryId: number | null;
	dimInventoryName: string;
	dimInventoryType: string;
	measuringUnit: string;
	number: string;
	money: string;
	source: "凭证" | "票据" | "录入"; // 1.凭证  2.票据  3.录入
	voucherNo: string;
	invoiceNo: string;
	oppositeInventory: number | null;
	oppositeInventoryName: string;
	type: number; // 类型 0:入库 1:出库
	accountBookId = "";
	period = "";
	id?: number;
	price: string | number;
	remark?: string;

	constructor() {
		this.orderDate = "";
		this.dimInventoryNo = "";
		this.dimInventoryId = null;
		this.dimInventoryName = "";
		this.dimInventoryType = "";
		this.measuringUnit = "";
		this.number = "";
		this.money = "";
		this.source = "录入";
		this.voucherNo = "";
		this.invoiceNo = "";
		this.oppositeInventory = null;
		this.oppositeInventoryName = "";
		this.type = 1;
		this.price = "";
	}
}

@Component({
	components: {
		"choose-subject": ChooseSubjectVue,
		dropdown: DropdownVue,
		"month-selector": MonthSelectorVue,
		"print": PrintVue
	},
})
export default class InventoryOrder extends Vue {
	getCommands = ["发票数据", "凭证数据"];
	multiCommands = ["修改时间", "批量删除", "批量打印"];
	getCommand = "";
	multiCommand = "";
	multiTitle = "批量";

	inventoryTypeList = DimInventoryTypeList;
	dimInventoryList: Assist.AssistAccount[] = [];
	typeVal: { id: null | string } | null = null;
	invVal: { id: null | string } | null = null;

	currentTab = "0";

	downLoad() {
        let url = `${Vue.axios.defaults.baseURL}export/inventory/order?accountBookId=${this.$store.state.accountBook.id}&endPeriod=${this.period}&token=${this.$store.state.account.token}&version=${version}&inventoryOrderType=${this.currentTab}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }

	async fetchDimList() {
		if (this.dimInventoryList.length === 0) {
			const res = await Vue.axios.post(
				`dim/find?accountBookId=${this.$store.state.accountBook.id}&dimAccountType=存货`
			);
			res.data.unshift({
				id: null,
				name: "全部",
				no: "",
			});
			this.dimInventoryList = res.data;
		}
	}

	isAll = false;
	dataList: InventoryOrderData[] = [];
	newOrder = new InventoryOrderData();
	editRow = -1;

	period = "";

	async mounted() {
		// await this.fetchDimList();
		// await this.fetchData();
	}

	async fetchData() {
		if (
			this.typeVal &&
			this.invVal &&
			this.typeVal !== null &&
			this.invVal !== null
		) {
			this.multiCommand = "";
			this.isAll = false;
			const res = await Vue.axios.post("inventory/order/find", {
				dimInventoryType: this.typeVal.id,
				dimInventoryId: this.invVal.id,
				inventoryOrderType: this.currentTab,
				endPeriod: this.period,
				accountBookId: this.$store.state.accountBook.id,
			});
			res.data.forEach((e: InventoryOrderData) => {
				e.checked = false;
			});
			this.dataList = res.data;
		}
	}

	checkedList: number[] = [];
	checkedListData: InventoryOrderData[] = [];
	@Watch("dataList", { deep: true })
	listChange(val: InventoryOrderData[]) {
		const ids: number[] = [];
		const list: InventoryOrderData[] = [];
		val.forEach((e) => {
			if (e.checked && e.id) ids.push(e.id);
			else this.isAll = false;
		});
		this.checkedList = ids;
		this.getBtnTitle();
	}

	async changeDate(date: string) {
		this.period = date;
		await this.fetchDimList();
		this.fetchData();
	}

	// id获取商品类型名称
	getTypeText(id?: number | null) {
		let idStr = "";
		if (id && id !== null) idStr = id.toString();
		for (let i = 0; i < this.inventoryTypeList.length; i++) {
			if (this.inventoryTypeList[i].id === idStr)
				return this.inventoryTypeList[i].text;
		}
		return "";
	}
	getDimInventory(id: number) {
		for (let i = 0; i < this.dimInventoryList.length; i++) {
			if (this.dimInventoryList[i].id === id)
				return this.dimInventoryList[i];
		}
		return null;
	}

	// 选择存货后，单价自动填写
	async getPrice(data: InventoryOrderData) {
		const res = await Vue.axios.get(
			`inventory/order/balance?dimInventoryId=${data.dimInventoryId}&period=${this.period}&accountBookId=${this.$store.state.accountBook.id}`
		);
		if (res.data.data !== 0) data.price = res.data.data;
	}

	// 选择存货后，自动填写相关数据
	async changeNewInv(id: number) {
		const dimInventory = this.getDimInventory(id);
		if (dimInventory !== null) {
			this.newOrder.dimInventoryType = this.getTypeText(
				dimInventory.type
			);
			this.newOrder.measuringUnit = <string>dimInventory.measureUnit;
			await this.getPrice(this.newOrder);
			this.save(this.newOrder, true);
		}
	}

	// 存储出库单
	async save(
		data: InventoryOrderData,
		isNew?: boolean,
		isNumberPrice?: boolean,
		isMoney?: boolean,
		isInv?: boolean
	) {
		if (isNumberPrice) this.calcMoney(data);
		else if (isMoney) this.calcPrice(data);
		else if (isInv) {
			await this.getPrice(data);
		}
		if (
			data.orderDate !== "" &&
			data.orderDate !== null &&
			data.dimInventoryId !== null &&
			data.number !== "" &&
			data.money !== "" &&
			data.oppositeInventory !== null
		) {
			if (isNew) {
				data.accountBookId = this.$store.state.accountBook.id;
				data.period = this.period;
			}
			await Vue.axios.post("inventory/order/save", data);
			if (isNew) this.newOrder = new InventoryOrderData();
			// this.$forceUpdate();
			await this.fetchData();
		}
	}

	// 点击全选
	checkAll(val: boolean) {
		this.dataList.forEach((v) => {
			v.checked = val;
		});
	}

	// 获取按钮名称/操作
	getBtnTitle() {
		if (this.checkedList.length === 0) {
			this.multiTitle = "取消";
			return;
		} else {
			switch (this.multiCommand) {
				case "修改时间":
					this.multiTitle = "修改";
					break;
				case "批量删除":
					this.multiTitle = "删除";
					break;
				case "批量打印":
					this.multiTitle = "打印";
					break;
				default:
					this.multiTitle = "取消";
					break;
			}
		}
	}

	// 点击批量
	clickMulti(cmd: "修改时间" | "批量删除") {
		this.multiCommand = cmd;
		this.multiTitle = "取消";
	}

	setPickerVal(picker: VNode, val: string) {
		if (picker.componentInstance) {
			const input = picker.componentInstance.$el.querySelector("input");
			if (input !== null) input.value = val;
		}
	}

	async confirmMulti() {
		const h = this.$createElement;
		switch (this.multiTitle) {
			case "修改":
				const today = this.$utils.simpleDateFormat(
					new Date(),
					"d",
					true
				);
				let destDate: string = today;
				const picker = h("el-date-picker", {
					props: {
						value: destDate,
						"value-format": "yyyy-MM-dd",
						type: "date",
						clearable: false,
					},
					on: {
						input: (val: string) => {
							destDate = val;
							this.setPickerVal(picker, val);
						},
					},
				});
				try {
					await this.$msgbox({
						title: "亲，请选择日期",
						message: picker,
						showCancelButton: true,
					});
					await Vue.axios.post(
						`inventory/order/modify?ids=${this.checkedList.join(
							","
						)}&newDate=${destDate}`
					);
					await this.fetchData();
					this.setPickerVal(picker, today);
					break;
				} catch (e) {
					this.setPickerVal(picker, today);
					break;
				}
			case "删除":
				if (this.checkedList.length > 0) {
					await this.$confirm(
						`亲，确定要删除选中的 ${this.checkedList.length} 条单据吗？`,
						"温馨提示"
					);
					await Vue.axios.post(
						`inventory/order/delete?ids=${this.checkedList.join(
							","
						)}`
					);
				}
				await this.fetchData();
				break;
			case "打印":
				if (this.checkedList.length > 0) {
					try {
						await this.$confirm("亲，请选择打印方式", {
							message: `<div>
							<input type="radio" checked value="${0}" name="printWay" >合并打印
							<input type="radio" value="${1}" name="printWay">分别打印
						</div>`,
							title: "亲，请选择打印方式",
							confirmButtonText: "打印",
							cancelButtonText: "取消",
							dangerouslyUseHTMLString: true,
						});
						const printWay = (<HTMLInputElement>(
							document.querySelector(
								"input[name='printWay']:checked"
							)
						)).value;
						this.printWay = +printWay;
						this.checkedListData = [];
						this.dataList.forEach(e => {
							if (e.checked) this.checkedListData.push(e);
						});
						this.printVisble = true;
					} catch (e) {

					}					
				}
				break;
			default:
				this.multiCommand = "";
		}
	}

	// 点击提取
	async clickGet(cmd: string) {
		try {
			// await this.$confirm(`亲，确定要提取 ${cmd} 吗？`);
			let type = "";
			if (cmd === "发票数据") type = "invoice";
			else type = "voucher";
			const res = await Vue.axios.get(
				`inventory/order/get/by/${type}?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}&inventoryOrderType=${this.currentTab}`
			);
			if (res.data.message) this.$message.success(res.data.message);
			this.fetchData();
		} catch (e) {}
	}

	// 计算金额
	calcMoney(data: InventoryOrderData) {
		if (
			data.number !== "" &&
			data.price !== "" &&
			+data.price !== 0 &&
			+data.number !== 0
		)
			data.money = (+data.number * +data.price).toString();
	}
	calcPrice(data: InventoryOrderData) {
		if (
			data.money !== "" &&
			data.number !== "" &&
			+data.money !== 0 &&
			+data.number !== 0
		)
			data.price = (+data.money / +data.number).toString();
	}

	selectInner(e: FocusEvent) {
		(<HTMLInputElement>e.target).select();
	}

	// 打印modal
	printVisble = false;
	printWay = 0;
}
